/**
 * Domainübergreifendes Consent-Cookie (propora.de + tools.propora.de), Format
 * verbindlich abgestimmt mit dem parallelen Consent-Auftrag im propora-web-Repo.
 * Siehe TRACKING-CONSENT-IMMO-TOOLS.md, Punkt 1b.
 */

export const CONSENT_COOKIE_NAME = "propora_consent";
const CONSENT_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 180; // 180 Tage

export interface ConsentValue {
  analytics: boolean;
  marketing: boolean;
  ts: string;
}

export function parseConsentCookie(raw: string | undefined | null): ConsentValue | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    if (typeof parsed?.analytics === "boolean" && typeof parsed?.marketing === "boolean") {
      return {
        analytics: parsed.analytics,
        marketing: parsed.marketing,
        ts: typeof parsed.ts === "string" ? parsed.ts : new Date().toISOString(),
      };
    }
  } catch {
    // Kaputtes/fremdes Cookie -> wie "nicht vorhanden" behandeln.
  }
  return null;
}

export function serializeConsentCookie(value: ConsentValue): string {
  const encoded = encodeURIComponent(JSON.stringify(value));
  return `${CONSENT_COOKIE_NAME}=${encoded}; Domain=.propora.de; Path=/; SameSite=Lax; Secure; Max-Age=${CONSENT_COOKIE_MAX_AGE_SECONDS}`;
}

export function readConsentCookieFromDocument(): ConsentValue | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${CONSENT_COOKIE_NAME}=([^;]*)`));
  return parseConsentCookie(match?.[1]);
}

export function writeConsentCookie(value: ConsentValue): void {
  if (typeof document === "undefined") return;
  document.cookie = serializeConsentCookie(value);
}

/**
 * Consent-Mode-v2-Payload für gtag('consent', ...). functionality/security_storage
 * sind nicht personenbezogen und daher immer 'granted' (Standard-Konvention von Google).
 */
export function consentToGtagConsentPayload(value: ConsentValue | null) {
  const analyticsGranted = value?.analytics ? "granted" : "denied";
  const marketingGranted = value?.marketing ? "granted" : "denied";
  return {
    analytics_storage: analyticsGranted,
    ad_storage: marketingGranted,
    ad_user_data: marketingGranted,
    ad_personalization: marketingGranted,
    functionality_storage: "granted",
    security_storage: "granted",
  };
}
